import { marketplaceType } from "@redotech/redo-model/catalog/catalog";
import { Product2AttributeSchema } from "@redotech/redo-model/product2/product2-attribute-types";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { CatalogProductWithInventorySchema_ } from "./get-marketplace-products";

const CatalogProductWithInventoryAndAttributesSchema_ =
  CatalogProductWithInventorySchema_.extend({
    attributes: z.array(Product2AttributeSchema),
  });

export const CatalogProductWithInventoryAndAttributesSchema: z.ZodType<CatalogProductWithInventoryAndAttributes> =
  CatalogProductWithInventoryAndAttributesSchema_;
export interface CatalogProductWithInventoryAndAttributes
  extends z.infer<typeof CatalogProductWithInventoryAndAttributesSchema_> {}

const paginationInputSchema = z.object({
  limit: z.number().min(1).optional(),
  offset: z.number().min(0).optional(),
});

export const getMarketplaceProductsByVendor = {
  name: "getMarketplaceProductsByVendor" as const,
  input: z.object({
    marketplaceType: createEnum(marketplaceType),
    vendor: z.string(),
    pagination: paginationInputSchema.optional(),
  }),
  output: z.object({
    products: z.array(CatalogProductWithInventoryAndAttributesSchema),
    totalCount: z.number(),
  }),
};
